function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#5F1FFC",
  d: "M85 41h590v492H85z"
}), React.createElement("path", {
  fill: "#E2EBF9",
  d: "M0 269h420v317H0z"
}), React.createElement("path", {
  fill: "#000",
  d: "M238 14h85.327L404 103.246V234H238z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M250.834 0v221.227H418.43V62.848L355.582 0z"
}), React.createElement("path", {
  fill: "#000",
  d: "M356.308 0v62.848h62.848z"
}), React.createElement("path", {
  d: "M309.311 109.704l-8.087 19.94h16.175l-8.088-19.94zm15.827 39.183l-4.95-12.34h-21.753l-4.95 12.34h-8.506l20.01-49.92h8.645l20.01 49.92h-8.506zm28.167-4.81c6.135 0 9.133-4.114 9.133-8.995v-.348c-1.116-.418-3.625-1.116-6.972-1.116-6.275 0-9.064 2.51-9.064 5.578 0 3.207 2.998 4.88 6.903 4.88zm9.482 5.089l-.21-4.323c-2.58 3.626-6.623 5.23-11.364 5.23-7.25 0-12.62-3.766-12.62-10.598 0-7.879 7.182-11.504 16.315-11.504 3.835 0 6.414.697 7.53 1.116v-3.765c0-4.532-3.207-6.693-7.25-6.693-4.742 0-7.391 2.858-8.298 5.995l-6.972-2.37c1.743-5.508 6.694-10.04 15.478-10.04 8.506 0 14.99 4.253 14.99 13.805v23.147h-7.6z",
  fill: "#5F1FFC"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#000",
  d: "M97 319h232v306H97z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M85 307h232v306H85z"
}), React.createElement("path", {
  d: "M166.732 431.091l-12.874 31.74h25.748l-12.874-31.74zm25.193 62.371l-7.88-19.643H149.42l-7.88 19.643H128L159.851 414h13.762l31.851 79.462h-13.54zm44.836-7.658c9.766 0 14.539-6.547 14.539-14.316v-.555c-1.776-.666-5.771-1.776-11.099-1.776-9.988 0-14.427 3.996-14.427 8.879 0 5.105 4.772 7.768 10.987 7.768zm15.093 8.102l-.333-6.88c-4.106 5.77-10.543 8.323-18.09 8.323-11.541 0-20.087-5.993-20.087-16.87 0-12.54 11.431-18.311 25.97-18.311 6.104 0 10.21 1.11 11.986 1.776v-5.993c0-7.214-5.106-10.654-11.542-10.654-7.547 0-11.764 4.55-13.207 9.544l-11.098-3.773c2.774-8.768 10.654-15.982 24.637-15.982 13.54 0 23.861 6.77 23.861 21.974v36.846h-12.097z",
  fill: "#5F1FFC"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#000",
  d: "M458 222h157.836v208.931H458z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M469 210.876h157.836v208.931H469z"
}), React.createElement("path", {
  fill: "#000",
  d: "M558.803 202h8.164v18.435h-8.164zM509.82 202h8.164v18.435h-8.164zM607.787 202h8.164v18.435h-8.164zM493.492 202h8.164v18.435h-8.164zM591.459 202h8.164v18.435h-8.164zM542.475 202h8.164v18.435h-8.164zM477.164 202h8.164v18.435h-8.164zM575.131 202h8.164v18.435h-8.164zM526.148 202h8.164v18.435h-8.164z"
}), React.createElement("path", {
  d: "M489.75 299.773h107.413M489.75 358.277h107.413M489.75 329.426h96.227M489.75 270.12h75.965M489.75 387.93h75.965",
  stroke: "#E7E7E7",
  strokeWidth: 12.8,
  strokeLinecap: "square"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 675,
    height: 625,
    viewBox: "0 0 675 625"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/howitworks_3.7e0830f8.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/static/landing/howitworks_3.svg
// module id = 395
// module chunks = 0